(function () {
    'use strict';

    angular
        .module('cog.shared')
        .directive('cogScheduleLine', scheduleLineDirective);

    /* @ngInject */
    function scheduleLineDirective($location, $compile) {
        //var singleTemplate = '<input type="text" ng-model="vm.val" />&nbsp;<span ng-bind-html="::vm.getFormat(lines[0])" />';
        //var comboTemplate = '<input type="text" ng-model="vm.val" />&nbsp;<select ng-model="vm.lineSelect"><option ng-selected="{{vm.lineSelect== i.Id}}" ng-repeat="i  in ::lines" ng-bind-html="::vm.getFormat(i)" value="{{::i.Id}}"></option></select>';
        var singleTemplate;
        var comboTemplate = singleTemplate = '<md-button ng-class="(vm.selected==true)?\'hasBetBtn\':\'\'" ng-click="vm.buyPoints(lines)" class="md-raised btnSchedule" md-no-ink ng-bind-html="vm.btnLineLbl" aria-label="btn"></md-button>';

        var directive = {
            restrict: 'E',
            replace: true,
            scope: {
                lines: "=lines",
                wt: "@",
                lineData: "@linedata",
                teamlines: "=teamlines",
                logo: "="
            },
            //templateUrl: function(elem, attr){return 'app/core/components/schedule/schedule-line-' + attr.type + '.tmpl.html';},
            controller: scheduleLineDirectiveController,
            controllerAs: 'vm',
            compile: compile,
            // link: { post: postLink }
        };
        return directive;

        function compile(tElem, tAttrs) {
            // $compile(element.contents())(scope);
            //tElem.append('<b> test')
            return function ($scope, $element, $attrs) {
                if ($scope.lines) {
                    if ($scope.lines.length == 1) {
                        $element.html(singleTemplate);
                        $compile($element.contents())($scope);
                    } else if ($scope.lines.length > 1) {
                        $element.html(comboTemplate);
                        $compile($element.contents())($scope);
                    }
                }
            };
        }

        function postLink($scope, $element, $attrs) {
            if ($scope.lines) {
                if ($scope.lines.length == 1) {
                    $element.html(singleTemplate);
                    $compile($element.contents())($scope);
                } else if ($scope.lines.length > 1) {
                    $element.html(comboTemplate);
                    $compile($element.contents())($scope);
                }
            }
        }
    }

    /* @ngInject */
    function scheduleLineDirectiveController($scope, customerGameSelection: ICustomerSelection, $mdDialog, $mdToast, $filter, lineFormater, accountService: IAccountService, BET_TYPES, $rootScope, $state, LINE_BET_SELECTION, CogApiServiceProvider: ICogApiServiceProvider, PendingWagerTransformer: IPendingWagerTransformer, $window, notificationService: INotificationService, betModelTransformer: IBetTranformer, appSettings) {

        var vm = this;
        vm.getFormat = getFormat;
        vm.lineSelect = null;
        vm.getId = getId;
        vm.val = "";
        vm.buyPoints = buyPoints;
        vm.btnLineLbl = "...";
        vm.selected = false;
        vm.is_bm = CogApiServiceProvider.is_BM();
        var lineData = JSON.parse($scope.lineData);
        var defaultLine = _lessOdds($scope.lines);
        var betType = accountService.getBetSelectionType();
        //var fillSpotDialog;
        //var LineBetDialog;

        // for bet calculation data
        var calcType: string = 'A';
        //var betVal: number = 0;
        var riskVal: number = 0;
        var winVal: number = 0;
        var max_single_bets: number = 10;// for straights, contest & if bets

        activate();

        ////////////////

        notificationService.subscribe_MSG_SAVE_SELECTION($scope, function (event, message) {
            if (vm.selected) {
                var amt = parseInt(vm.val.toString().trim());
                var _add = ((betType == BET_TYPES.S.type || betType == BET_TYPES.E.type) && !isNaN(amt)) ? true : false;
                if (_add) {
                    var gameLineData = getGameLineData();
                    var gmSelItem: IGameSelectionItem = new GameSelectionItem();
                    gmSelItem.key = vm.lineSelect.Id;
                    gmSelItem.amount = amt;
                    gmSelItem.lineDetail = gameLineData;
                    gmSelItem.period = gameLineData.scheduleData.Period;
                    gmSelItem.pitcherData = lineData.pitcherData;
                    gmSelItem.calcType = customerGameSelection.gameSelections.getCalcType();
                    gmSelItem.lines = $scope.lines;
                    customerGameSelection.gameSelections.Add(gmSelItem);
                }
            }
        });

        function getGameLineData() {
            //return { scheduleData: lineData.scheduleData, gameLbl: lineData.gameNote, teamLbl: lineData.teamName, points: getFormat(vm.lineSelect, true) };
            return getGameLineDataObj(lineData);
        }

        function getGameLineDataObj(lineData) {
            return { scheduleData: lineData.scheduleData, gameLbl: lineData.gameNote, teamLbl: lineData.teamName, points: getFormat(vm.lineSelect, true), riskVal: riskVal, winVal: winVal, calcType: calcType, gameId: lineData.gameId };
        }

        function activate() {
            if ($scope.lines) {
                vm.lineSelect = defaultLine;
                if (vm.lineSelect != null)
                    setBtnLineLbl();
                // check if selected
                if (betType == BET_TYPES.E.type || betType == BET_TYPES.S.type)
                    checkSelected();
                fixTeamNames();
            }
        }

        // check if gameSelection.Items has the line to set it as selected in display
        function checkSelected() {
            if (customerGameSelection.gameSelections.Items.length > 0) {
                var _line = $window._.map($scope.lines, function (o) {
                    var idx: number = $window._.findIndex(customerGameSelection.gameSelections.Items, function (g) {
                        return g.Key == o.Id;
                    });
                    if (idx >= 0) {
                        return { 'line': o, 'item': customerGameSelection.gameSelections.Items[idx] };
                    }
                });
                if (_line != null && _line.length > 0) {
                    $window._.forEach(_line, function (value, key) {
                        if (value != null && value != undefined) {
                            vm.selected = true;
                            vm.lineSelect = _line[key].line;
                            vm.val = _line[key].item.Amount;
                            riskVal = _line[key].item.lineDetail.riskVal;
                            winVal = _line[key].item.lineDetail.winVal;
                            setBtnLineLbl();
                        }
                    });
                }
            }
        }

        function setBtnLineLbl() {
            if (vm.lineSelect == null) {
                vm.lineSelect = defaultLine;
            }
            vm.btnLineLbl = getFormat(vm.lineSelect, true);
        }

        function getTemplate() {
            var linetype = 'none';
            if ($scope.lines) {
                if ($scope.lines.length == 1)
                    linetype = 'single';
                else
                    linetype = 'combo';
            }
            return linetype;
        }

        function getId() {
            var id = "";
            if ($scope.lines && $scope.lines.length > 0) {
                id = $scope.lines[0].Id;
            }
            return id;
        }

        function getFormat(line, useSpan: boolean): string {
            return betModelTransformer.getLineFormat(line, useSpan);
        }
       
        function arrBasePoints(arr) {
            var arrTemp = [];
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].BuyPoints === 0) {
                    arr[i].Idx = i;
                    arrTemp.push(arr[i]);
                }
            }
            return arrTemp;
        }

        function getLowestJuice(arrT1, arrT2) {
            var arrTemp1 = arrBasePoints(arrT1);
            var arrTemp2 = arrBasePoints(arrT2);
            var arrSort = [];
            var tmp = 1000000, idx = -1;
            for (var i = 0; i < arrTemp1.length; i++) {
                var odds = arrTemp1[i].Odds;
                var dataLine = lineFormater.data(arrTemp1[i].Id);
                for (var j = 0; j < arrTemp2.length; j++) {
                    var otherLine = lineFormater.data(arrTemp2[j].Id);
                    if (otherLine.GameId == dataLine.GameId) {
                        if (arrTemp2[j].Odds < odds)
                            odds = arrTemp2[j].Odds;
                        if (Math.abs(odds) < Math.abs(tmp)) {
                            tmp = odds;
                            arrSort.push({ Idx: arrTemp1[i].Idx, Odds: Math.abs(tmp), GameId: dataLine.GameId });
                        }
                    }
                }
                tmp = 1000000;
            }
            if (arrSort.length > 0) {
                arrSort = $filter('orderBy')(arrSort, ['Odds', 'GameId'], false);
                idx = arrSort[0].Idx;
            }
            return idx;
        }
        /*
        function _lessOdds(arr) {
            var tmp = 1000000, idx = -1;
            if (arr != null && arr.length > 0) {
                var arrBase = arrBasePoints(arr);
                var dataLine = lineFormater.data(arrBase[0].Id);

                if (arrBase[0].Id =='0_164596202_-0.5_-105_0_0_0') debugger

                var _teamLines = (dataLine.IsVisitor) ? $scope.teamlines.team2Lines : $scope.teamlines.team1Lines;
                if (dataLine.IsTeamTotal) {
                    if (dataLine.Type == "TO") _teamLines = $scope.teamlines.team2Lines;
                    if (dataLine.Type == "TU") _teamLines = $scope.teamlines.team1Lines;
                }

                var tLines = arrBasePoints(_teamLines);

                for (var i = 0, len = arrBase.length; i < len; i++) {
                    var odds = arrBase[i].Odds;
                    dataLine = lineFormater.data(arrBase[i].Id);
                    for (var j = 0; j < tLines.length; j++) {
                        var otherLine = lineFormater.data(tLines[j].Id);
                        if (otherLine.GameId == dataLine.GameId) {
                            if (tLines[j].Odds < odds)
                                odds = tLines[j].Odds;
                            if (Math.abs(odds) < Math.abs(tmp)) {
                                idx = arrBase[i].Idx;
                                tmp = odds;
                            }
                        }
                    }
                }
                if (idx != -1)
                    return arr[idx];
            }
            return null;
        }
        */
        function _lessOdds(arr) {
            var idx = -1;
            if (arr != null && arr.length > 0) {
                var dataLine = lineFormater.data(arr[0].Id);
                var _teamLines = (dataLine.IsVisitor) ? $scope.teamlines.team2Lines : $scope.teamlines.team1Lines;
                if (dataLine.IsTeamTotal) {
                    if (dataLine.Type == "TO") _teamLines = $scope.teamlines.team2Lines;
                    if (dataLine.Type == "TU") _teamLines = $scope.teamlines.team1Lines;
                }

                idx = getLowestJuice(arr, _teamLines);   
                             
                if (idx != -1)
                    return arr[idx];                
            }
            return null;
        }

        function _truncate(number, places) {
            var shift = Math.pow(10, places);
            return ((number * shift) | 0) / shift;
        };

        ///////////////////////////////////////////

        function getWagerTypeTitle() {
            var wagerTypeStr = "Wager";
            switch ($scope.wt.toUpperCase()) {
                case 'S':
                    wagerTypeStr = "Spread";
                    break;
                case 'M':
                    wagerTypeStr = "Money Line";
                    break;
                case 'T':
                    wagerTypeStr = "Total";
                    break;
                case 'E':
                    wagerTypeStr = "Team Total";
                    break;
            }
            return wagerTypeStr;
        }

        function processMultiplesBetType() {
            // for Parlay, Teaser & AR
            var maxReached = checkMaxTeamsReached();
            if (!maxReached || vm.selected) {
                if (!vm.selected) {
                    vm.selected = true;
                    var gameLineData = getGameLineData();
                    lineData.pitcherData.p1Selected = $("#p1_" + lineData.gameId).val() === '1' && $("#p1_" + lineData.gameId).is(":enabled") ? true : false;
                    lineData.pitcherData.p2Selected = $("#p2_" + lineData.gameId).val() === '1' && $("#p2_" + lineData.gameId).is(":enabled") ? true : false;

                    var gmSelItem: IGameSelectionItem = new GameSelectionItem();
                    gmSelItem.key = vm.lineSelect.Id;
                    gmSelItem.amount = 0;
                    gmSelItem.lineDetail = gameLineData;
                    gmSelItem.period = gameLineData.scheduleData.Period;
                    gmSelItem.pitcherData = lineData.pitcherData;
                    gmSelItem.calcType = customerGameSelection.gameSelections.getCalcType();
                    gmSelItem.lines = $scope.lines;

                    var valid: boolean = true;
                    var dataAdd = lineFormater.data(gmSelItem.key);
                    if (betType === BET_TYPES.P.type && customerGameSelection.gameSelections.Items.length > 0) {
                        angular.forEach(customerGameSelection.gameSelections.Items, function (gameItem, i) {
                            if (lineData.gameId === gameItem.lineDetail.gameId && valid) {
                                var dataCurrent = lineFormater.data(gameItem.Key);

                                if (dataAdd.Type.length > 1)
                                    dataAdd.Type = dataAdd.Type.slice(0, 1);
                                if (dataCurrent.Type.length > 1)
                                    dataCurrent.Type = dataCurrent.Type.slice(0, 1);

                                if (
                                    dataAdd.Type == dataCurrent.Type ||
                                    (dataAdd.Type == 'S' && dataCurrent.Type == 'M') || (dataAdd.Type == 'M' && dataCurrent.Type == 'S') ||
                                    (
                                        (
                                            (gameItem.lineDetail.scheduleData.Sport == "Baseball" && gmSelItem.lineDetail.scheduleData.Sport == "Baseball") ||
                                            (gameItem.lineDetail.scheduleData.Sport == "Hockey" && gmSelItem.lineDetail.scheduleData.Sport == "Hockey")
                                        )
                                        &&
                                        (
                                            (dataAdd.Type == 'S' && dataCurrent.Type == 'T') || (dataAdd.Type == 'T' && dataCurrent.Type == 'S')
                                        )
                                    )
                                ) {
                                    valid = false;

                                    $mdDialog.show(
                                        $mdDialog.alert()
                                            .title("Invalid Selection")
                                            .htmlContent(
                                            gameItem.lineDetail.teamLbl + " " + gameItem.lineDetail.points + "<br>" +
                                            gmSelItem.lineDetail.teamLbl + " " + gmSelItem.lineDetail.points
                                            )
                                            .ok("Close")
                                    );
                                }
                            }
                        });
                    }

                    if (valid)
                        //customerGameSelection.gameSelections.Add(vm.lineSelect.Id, 0, gameLineData, gameLineData.scheduleData.Period, lineData.pitcherData, customerGameSelection.gameSelections.getCalcType());
                        customerGameSelection.gameSelections.Add(gmSelItem);
                    else
                        vm.selected = false;
                }
                else {
                    customerGameSelection.gameSelections.Remove(vm.lineSelect.Id);
                    vm.selected = false;
                }
                onBetEvent();
            } else {
                var tpDesc = accountService.getBetSelectionDesc();
                var msg = 'Max wager reached for ' + tpDesc;
                $mdToast.show(
                    $mdToast.simple()
                        .content(msg)
                        .position('bottom right')
                        .hideDelay(2500)
                );
            }
        }

        function checkMaxTeamsReached() {
            var reached: boolean = false;
            var maxTeamsAllow = customerGameSelection.getMaxTeamsAllow();
            if (maxTeamsAllow > 0 && maxTeamsAllow <= customerGameSelection.gameSelections.Items.length) {
                reached = true;
            }
            return reached;
        }

        function onBetEvent() {
            if (vm.is_bm) {
                //$rootScope.$emit('MSG_BM_BET_EVENT');
                notificationService.notify_MSG_BM_BET_EVENT();
            } else {
                //$rootScope.$emit('MSG_BET_SELECT');
                notificationService.notify_MSG_BET_SELECT();
            }
        }

        function processFillSpot(lines) {
            /*fillSpotDialog = */$mdDialog.show({
                controller: 'FillSpotDialogController',
                controllerAs: 'vm',
                templateUrl: appSettings.sharedPath + 'schedule/fill-spot-dialog.tmpl.html',
                locals: {
                    lines: lines,
                    lineSelect: vm.lineSelect,
                    getFormat: getFormat,
                    lineData: lineData,
                    selected: vm.selected,
                    getGameLineDataObj: getGameLineDataObj
                    , bindToController: true
                }
            }).then(function (lineBet) {
                if (lineBet != null) {
                    switch (lineBet.action) {
                        case 1: // save bet
                            vm.val = "";
                            vm.lineSelect = lineBet.line;
                            vm.selected = true;
                            break;
                        case 0: // cancel
                            vm.val = "";
                            vm.lineSelect = null;
                            vm.selected = false;
                            if (vm.is_bm)
                                //$rootScope.$emit('MSG_BM_FILLOPEN_EVENT');
                                notificationService.notify_MSG_BM_FILLOPEN_EVENT();
                            break;
                    }
                }
                setBtnLineLbl();
            }, betCancel);
        }

        vm.$onDestroy = function () {
            /*if (fillSpotDialog) {
                $mdDialog.cancel();
            }
            if (LineBetDialog) {
                $mdDialog.cancel();
            }*/
            $mdDialog.cancel();
        };

        function buyPoints(lines) {
            if (!vm.is_bm) {
                var isFillSpot: boolean = customerGameSelection.openSpots.isFillSpot;
                if (isFillSpot) {
                    processFillSpot(lines);
                } else {
                    var _continue: boolean = true;
                    var ttlBets: number = customerGameSelection.gameSelections.Items.length;
                    if (betType == BET_TYPES.S.type || betType == BET_TYPES.E.type || betType == BET_TYPES.I.type) {
                        _continue = (ttlBets >= max_single_bets) ? false : true;
                    }
                    if (_continue) {
                        buyPointsCustomer(lines);
                    } else {
                        var betDesc: string = accountService.getBetSelectionDesc();
                        notificationService.showMessage('You are allowed to place a maximum of <strong>' + max_single_bets + '</strong> wagers for ' + betDesc + ' Bets');
                    }
                }
            } else {
                buyPointsBM(lines);
            }
        }

        function buyPointsCustomer(lines) {
            var betAmount = (vm.val == "" || isNaN(vm.val) || vm.val < 1) ? '' : parseFloat(vm.val);
            var showMdl = false;
            if (vm.selected) {
                vm.selected = false;
                customerGameSelection.gameSelections.Remove(vm.lineSelect.Id);
                vm.lineSelect = defaultLine;
                vm.val = "";
                setBtnLineLbl();
                if (customerGameSelection.gameSelections.Items.length == 0)
                    notificationService.notify_showContinue(false);
                if ((betType != BET_TYPES.S.type && betType != BET_TYPES.E.type)) {
                    if (customerGameSelection.gameSelections.Items.length > 0) {
                        onBetEvent();
                    }
                }
            } else {
                if ((betType == BET_TYPES.S.type || betType == BET_TYPES.E.type || betType == BET_TYPES.I.type)) {
                    showMdl = true;
                } else {
                    processMultiplesBetType();
                }
            }
            if (showMdl) {
                $mdDialog.show({
                    controller: 'LineBetDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/core/components/schedule/line-bet-dialog.tmpl.html',
                    locals: {
                        lines: lines,
                        lineSelect: vm.lineSelect,
                        wagerType: $scope.wt,
                        betAmount: betAmount,
                        getFormat: getFormat,
                        lineData: lineData,
                        selection: LINE_BET_SELECTION.single,
                        selected: vm.selected,
                        calcData: { calcType: calcType, riskVal: riskVal, winVal: winVal },
                        logo: $scope.logo
                    },
                    fullscreen: false,
                    focusOnOpen: false
                }).then(function (lineBet) {
                    if (lineBet != null) {
                        //set calculation data
                        if (lineBet.calc != null && (betType == BET_TYPES.S.type || betType == BET_TYPES.E.type || betType == BET_TYPES.I.type)) {
                            calcType = lineBet.calc.calcType;
                            riskVal = lineBet.calc.riskVal;
                            winVal = lineBet.calc.winVal;
                        }
                        switch (lineBet.action) {
                            case 1:
                                vm.val = lineBet.amt;
                                vm.lineSelect = lineBet.line;
                                vm.selected = true;
                                break;
                            case 2:
                                vm.val = lineBet.amt;
                                vm.lineSelect = lineBet.line;
                                vm.selected = true;
                                if (vm.is_bm) {
                                    gotoConfirmStep();
                                }
                                else {
                                    //$scope.$emit('MSG_CONTINUE_BET');
                                    notificationService.notify_MSG_CONTINUE_BET();
                                }
                                break;
                            case 3: // ifbet & action reverse
                            case 4:
                                vm.val = lineBet.amt;
                                vm.lineSelect = lineBet.line;
                                vm.selected = true;
                                var gameLineData = getGameLineData();
                                var lineBetAmt = (betType == BET_TYPES.I.type) ? vm.val : 0;
                                var gmSelItem = new GameSelectionItem();
                                gmSelItem.key = vm.lineSelect.Id;
                                gmSelItem.amount = lineBetAmt;
                                gmSelItem.lineDetail = gameLineData;
                                gmSelItem.period = gameLineData.scheduleData.Period;
                                gmSelItem.pitcherData = lineData.pitcherData;
                                gmSelItem.calcType = customerGameSelection.gameSelections.getCalcType();
                                gmSelItem.lines = $scope.lines;
                                // remove any prev line selection
                                //if (lineBet.prevLine != null && lineBet.prevLine.Id != null && lineBet.prevLine.Id != "")
                                //    customerGameSelection.gameSelections.Remove(lineBet.prevLine.Id);
                                // add selected line
                                //customerGameSelection.gameSelections.Add(vm.lineSelect.Id, lineBetAmt, gameLineData, gameLineData.scheduleData.Period, lineData.pitcherData, customerGameSelection.gameSelections.getCalcType());
                                if (lineBet.prevLine != null && lineBet.prevLine.Id != null && lineBet.prevLine.Id != "" && lineBet.prevLine.Id != gmSelItem.key)
                                    customerGameSelection.gameSelections.Swap(lineBet.prevLine.Id, gmSelItem.key, false);
                                customerGameSelection.gameSelections.Add(gmSelItem);
                                if (betType == BET_TYPES.I.type && !vm.is_bm) {
                                    if (customerGameSelection.gameSelections.Items.length > 1)
                                        notificationService.notify_showContinue(true);
                                }
                                if (lineBet.action == 4) {
                                    gotoConfirmStep();
                                }
                                break;
                            case 5:
                                gotoConfirmStep();
                                break;
                            default:
                                vm.val = "";
                                vm.lineSelect = null;
                                vm.selected = false;
                                // reset calculation data
                                calcType = 'A';
                                riskVal = 0;
                                winVal = 0;
                                if ((betType == BET_TYPES.I.type) && lineBet.line != null) {
                                    customerGameSelection.gameSelections.Remove(lineBet.line.Id);
                                    onBetEvent();
                                    vm.selected = false;
                                }
                                break;
                        }
                        // if (vm.is_bm) {
                        if (betType == BET_TYPES.S.type || betType == BET_TYPES.E.type) {
                            if (vm.selected) {
                                vm.val = lineBet.amt;
                                var gameLineData = getGameLineData();
                                var gmSelItem = new GameSelectionItem();
                                gmSelItem.key = vm.lineSelect.Id;
                                gmSelItem.amount = lineBet.amt;
                                gmSelItem.lineDetail = gameLineData;
                                gmSelItem.period = gameLineData.scheduleData.Period;
                                gmSelItem.pitcherData = lineData.pitcherData;
                                gmSelItem.calcType = customerGameSelection.gameSelections.getCalcType();
                                gmSelItem.lines = $scope.lines;
                                //customerGameSelection.gameSelections.Add(vm.lineSelect.Id, vm.val = lineBet.amt, gameLineData, gameLineData.scheduleData.Period, lineData.pitcherData, customerGameSelection.gameSelections.getCalcType());
                                customerGameSelection.gameSelections.Add(gmSelItem);
                                if (!vm.is_bm && customerGameSelection.gameSelections.Items.length > 0)
                                    notificationService.notify_showContinue(true);
                            }
                            else {
                                customerGameSelection.gameSelections.Remove(lineBet.line.Id);
                                if (!vm.is_bm && customerGameSelection.gameSelections.Items.length == 0)
                                    notificationService.notify_showContinue(false);
                            }
                        }
                    }
                    setBtnLineLbl();
                }, betCancel);
            }
        }

        // original buy points method, now we use it only for BM
        function buyPointsBM(lines) {
            // check if is fill spot
            var isFillSpot: boolean = customerGameSelection.openSpots.isFillSpot;
            if (isFillSpot) {
                processFillSpot(lines);
            } else {
                switch (betType) {
                    case BET_TYPES.T.type:
                        processMultiplesBetType();
                        break;
                    case BET_TYPES.S.type:
                    case BET_TYPES.E.type:
                    case BET_TYPES.A.type:
                    case BET_TYPES.P.type:
                    case BET_TYPES.I.type:
                        var betAmount = (vm.val == "" || isNaN(vm.val) || vm.val < 1) ? 0 : parseFloat(vm.val);
                        var showMdl = true;
                        if (betType == BET_TYPES.A.type || betType == BET_TYPES.P.type) {
                            // Action reverse use general bet and not by each item
                            betAmount = customerGameSelection.gameSelections.GetBetAmount();
                            // check if has buypoints to show modal, if not select current
                            var linesLen = lines.length;
                            if (linesLen > 1) {
                                showMdl = true;
                            } else {
                                showMdl = false;
                                processMultiplesBetType();
                            }
                        }
                        if ((betType == BET_TYPES.S.type || betType == BET_TYPES.E.type) && vm.selected && !vm.is_bm) {
                            showMdl = false;
                            vm.selected = false;
                            customerGameSelection.gameSelections.Remove(vm.lineSelect.Id);
                            vm.lineSelect = defaultLine;
                            vm.val = "";
                            setBtnLineLbl();
                            if (customerGameSelection.gameSelections.Items.length == 0)
                                notificationService.notify_showContinue(false);
                        }
                        if (showMdl) {
                            /*LineBetDialog = */$mdDialog.show({
                                controller: (!vm.is_bm) ? 'LineBetDialogController' : 'BMBetDialogController',
                                controllerAs: 'vm',
                                templateUrl: (!vm.is_bm) ? 'app/core/components/schedule/line-bet-dialog.tmpl.html' : 'app/core/bm/components/schedule/bm-bet-dialog.tmpl.html',
                                locals: {
                                    lines: lines,
                                    lineSelect: vm.lineSelect,
                                    wagerType: $scope.wt,
                                    betAmount: betAmount,
                                    getFormat: getFormat,
                                    lineData: lineData,
                                    selection: LINE_BET_SELECTION.single,
                                    selected: vm.selected,
                                    calcData: { calcType: calcType, riskVal: riskVal, winVal: winVal },
                                    logo: $scope.logo
                                },
                                fullscreen: false,
                                focusOnOpen: false
                            }).then(function (lineBet) {
                                if (lineBet != null) {
                                    //set calculation data
                                    if (lineBet.calc != null && (betType == BET_TYPES.S.type || betType == BET_TYPES.E.type || betType == BET_TYPES.I.type)) {
                                        calcType = lineBet.calc.calcType;
                                        riskVal = lineBet.calc.riskVal;
                                        winVal = lineBet.calc.winVal;
                                    }
                                    switch (lineBet.action) {
                                        case 1:
                                            vm.val = lineBet.amt;
                                            vm.lineSelect = lineBet.line;
                                            vm.selected = true;
                                            break;
                                        case 2:
                                            vm.val = lineBet.amt;
                                            vm.lineSelect = lineBet.line;
                                            vm.selected = true;
                                            if (vm.is_bm) {
                                                gotoConfirmStep();
                                            } else {
                                                //$scope.$emit('MSG_CONTINUE_BET');
                                                notificationService.notify_MSG_CONTINUE_BET();
                                            }
                                            break;
                                        case 3: // ifbet & action reverse
                                        case 4: // ifbet & action reverse
                                            vm.val = lineBet.amt;
                                            vm.lineSelect = lineBet.line;
                                            vm.selected = true;
                                            var gameLineData = getGameLineData();
                                            var lineBetAmt = (betType == BET_TYPES.I.type) ? vm.val : 0;

                                            var gmSelItem: IGameSelectionItem = new GameSelectionItem();
                                            gmSelItem.key = vm.lineSelect.Id;
                                            gmSelItem.amount = lineBetAmt;
                                            gmSelItem.lineDetail = gameLineData;
                                            gmSelItem.period = gameLineData.scheduleData.Period;
                                            gmSelItem.pitcherData = lineData.pitcherData;
                                            gmSelItem.calcType = customerGameSelection.gameSelections.getCalcType();
                                            gmSelItem.lines = $scope.lines;

                                            // remove any prev line selection
                                            /*if (lineBet.prevLine != null && lineBet.prevLine.Id != null && lineBet.prevLine.Id != "")
                                                customerGameSelection.gameSelections.Remove(lineBet.prevLine.Id);
                                            // add selected line
                                            customerGameSelection.gameSelections.Add(vm.lineSelect.Id, lineBetAmt, gameLineData, gameLineData.scheduleData.Period, lineData.pitcherData, customerGameSelection.gameSelections.getCalcType());
                                            */

                                            if (lineBet.prevLine != null && lineBet.prevLine.Id != null && lineBet.prevLine.Id != "" && lineBet.prevLine.Id != gmSelItem.key)
                                                customerGameSelection.gameSelections.Swap(lineBet.prevLine.Id, gmSelItem.key, false);
                                            customerGameSelection.gameSelections.Add(gmSelItem);

                                            if (betType == BET_TYPES.A.type || betType == BET_TYPES.P.type) {
                                                customerGameSelection.gameSelections.SetBetAmount(vm.val);
                                                onBetEvent();
                                            }
                                            if (lineBet.action == 4) {
                                                gotoConfirmStep();
                                            }
                                            break;
                                        case 5: // ifbet & action reverse, when max teams reached we send to selstep1
                                            if (betType == BET_TYPES.A.type) {
                                                if (lineBet.amt > 0) {
                                                    customerGameSelection.gameSelections.SetBetAmount(lineBet.amt);
                                                }
                                            }
                                            gotoConfirmStep();
                                            break;
                                        default:
                                            vm.val = "";
                                            vm.lineSelect = null;
                                            vm.selected = false;
                                            // reset calculation data
                                            calcType = 'A';
                                            riskVal = 0;
                                            winVal = 0;
                                            if ((betType == BET_TYPES.P.type || betType == BET_TYPES.A.type || betType == BET_TYPES.I.type) && lineBet.line != null) {
                                                customerGameSelection.gameSelections.Remove(lineBet.line.Id);
                                                onBetEvent();
                                                vm.selected = false;
                                            }
                                            break;
                                    }
                                    // if (vm.is_bm) {
                                    if (betType == BET_TYPES.S.type || betType == BET_TYPES.E.type) {
                                        if (vm.selected) {
                                            vm.val = lineBet.amt;
                                            var gameLineData = getGameLineData();
                                            var gmSelItem: IGameSelectionItem = new GameSelectionItem();
                                            gmSelItem.key = vm.lineSelect.Id;
                                            gmSelItem.amount = lineBet.amt;
                                            gmSelItem.lineDetail = gameLineData;
                                            gmSelItem.period = gameLineData.scheduleData.Period;
                                            gmSelItem.pitcherData = lineData.pitcherData;
                                            gmSelItem.calcType = customerGameSelection.gameSelections.getCalcType();
                                            gmSelItem.lines = $scope.lines;
                                            //customerGameSelection.gameSelections.Add(vm.lineSelect.Id, vm.val = lineBet.amt, gameLineData, gameLineData.scheduleData.Period, lineData.pitcherData, customerGameSelection.gameSelections.getCalcType());
                                            customerGameSelection.gameSelections.Add(gmSelItem);
                                            if (!vm.is_bm && customerGameSelection.gameSelections.Items.length > 0)
                                                notificationService.notify_showContinue(true);
                                        } else {
                                            customerGameSelection.gameSelections.Remove(lineBet.line.Id);
                                            if (!vm.is_bm && customerGameSelection.gameSelections.Items.length == 0)
                                                notificationService.notify_showContinue(false);
                                        }
                                        //$rootScope.$emit('MSG_BM_BET_EVENT');
                                        if (vm.is_bm)
                                            notificationService.notify_MSG_BM_BET_EVENT();
                                    } else if (betType == BET_TYPES.I.type && vm.is_bm) {
                                        //$rootScope.$emit('MSG_BM_BET_EVENT');
                                        notificationService.notify_MSG_BM_BET_EVENT();
                                    }
                                    //}

                                }
                                setBtnLineLbl();
                            }, betCancel);
                        }

                }
            }
        }

        function validLineId(id: string) {
            var valid: boolean = false;
            if ($scope.lines.length > 0)
                valid = ($window._.findIndex($scope.lines, function (o) { return o.Id == id; }) >= 0) ? true : false;
            return valid;
        }

        /*var MSG_BM_BET_CANCEL_EVENT_handler = $rootScope.$on('MSG_BM_BET_CANCEL_EVENT', function (event, id: string) {
            //if (vm.is_bm) {
            if (validLineId(id)) {
                //if (vm.lineSelect != null && (vm.lineSelect.Id == id || validLineId(id))) {
                vm.val = "";
                vm.selected = false;
            }
            //}
        });
        $scope.$on('$destroy', MSG_BM_BET_CANCEL_EVENT_handler);*/
        notificationService.subscribe_MSG_BM_BET_CANCEL_EVENT($scope, function (event, id: string) {
            if (validLineId(id)) {
                vm.val = "";
                vm.selected = false;
            }
        });

        // in case gameselection is added but did not close dialog and not sending promise cause has err in fillopen request
        /*var MSG_FILLOPEN_BET_SET_FAIL_EVENT_handler = $rootScope.$on('MSG_FILLOPEN_BET_SET_FAIL_EVENT', function (event, data) {
            var id = data.id;
            var selected = data.selected;
            var lineBet = data.lineBet;
            if (validLineId(id)) {
                //if (vm.lineSelect != null && (vm.lineSelect.Id == id || validLineId(id))) {
                vm.val = "";
                vm.lineSelect = lineBet;
                vm.selected = selected;
            }
        });
        $scope.$on('$destroy', MSG_FILLOPEN_BET_SET_FAIL_EVENT_handler);*/
        notificationService.subscribe_MSG_FILLOPEN_BET_SET_FAIL_EVENT($scope, function (event, data) {
            var id = data.id;
            var selected = data.selected;
            var lineBet = data.lineBet;
            if (validLineId(id)) {
                //if (vm.lineSelect != null && (vm.lineSelect.Id == id || validLineId(id))) {
                vm.val = "";
                vm.lineSelect = lineBet;
                vm.selected = selected;
            }
        });

        /*var MSG_FILLOPEN_CANCEL_LEG_EVENT_handler = $rootScope.$on('MSG_FILLOPEN_CANCEL_LEG_EVENT', function (event, id: string) {
            if (validLineId(id)) {
                //if (vm.lineSelect != null && vm.lineSelect.Id == id) {
                vm.val = "";
                vm.lineSelect = defaultLine;
                vm.selected = false;
            }
        });
        $scope.$on('$destroy', MSG_FILLOPEN_CANCEL_LEG_EVENT_handler);*/
        notificationService.subscribe_MSG_FILLOPEN_CANCEL_LEG_EVENT($scope, function (event, id: string) {
            if (validLineId(id)) {
                vm.val = "";
                vm.lineSelect = defaultLine;
                vm.selected = false;
            }
        });
        function gotoConfirmStep() {
            if (!vm.is_bm) {
                $state.go('cog.default.customer-selstep1', { tp: vm.tp });
            } else {
                $state.go('bm.default.customer-selstep1');
            }
        }

        function betCancel() {
            $mdToast.show(
                $mdToast.simple()
                    .content('No Bet Applied - Cancelled')
                    .position('bottom right')
                    .hideDelay(2500)
            );
        }

        function fixTeamNames() {
            if (vm.lineSelect != null) {
                var data = lineFormater.data(vm.lineSelect.Id);
                if (data.IsTeamTotal) {
                    if (!vm.is_bm && lineData.teamMascot.length > 0)
                        lineData.teamName = lineData.teamMascot + " Team Total";
                    else
                        lineData.teamName = lineData.teamName + " Team Total";
                }
                if (data.IsTotal) {
                    if (!vm.is_bm && lineData.teamTotalMascot.length > 0)
                        lineData.teamName = lineData.teamTotalMascot;
                    else
                        lineData.teamName = lineData.teamTotalName;
                }
            }
        }
    }
})();
